export const routes = /** @type {const} */ ({
  pages: {
    estimations: {
      agent: {
        chat: "/estimations/agent/chat",
      },
    },
  },
  api: {
    estimation: {
      agent: {
        chat: "/estimation-api/agent/chat",
      },
    },
  },
})

/**
 * @param {string} route
 * @param {Record<string, string|undefined>} params
 * @returns {string}
 */
export function route(route, params = {}) {
  let path = route
  const requiredParams = route.match(/:\w+/g) ?? []

  requiredParams.forEach((param) => {
    const paramName = param.slice(1)
    const paramValue = params[paramName]

    if (!paramValue) {
      throw new Error(`Missing parameter ${param} in route ${route}`)
    }

    path = path.replace(param, paramValue)
  })

  return path
}
